export default __webpack_public_path__ + "static/media/testimonials.eac5e505.png";